export default "__VITE_ASSET__DwMvG3G1__"